import { useEffect } from 'react';

/**
 * How much of the top of the viewport the chrome covers (the prototype's `pinnedChromeH`): its
 * height while it is pinned (sticky, portrait), 0 when it scrolls away with the page
 * (chrome.css, `max-height: 500px`: landscape) or isn't there. Sticky things under it (the power
 * of attorney's language switch) and scroll offsets use this, never `offsetHeight` alone: in
 * landscape that left a chrome-sized gap above the stuck switch.
 */
export function pinnedChromeH(): number {
  const c = document.querySelector<HTMLElement>('.chrome');
  if (!c || c.hidden || getComputedStyle(c).position !== 'sticky') return 0;
  return c.getBoundingClientRect().height;
}

/** Keeps `--chrome-pin` on <html> equal to `pinnedChromeH()` through rotation and resizes. */
export function useChromePin(): void {
  useEffect(() => {
    const sync = () => document.documentElement.style.setProperty('--chrome-pin', `${pinnedChromeH()}px`);
    sync();
    window.addEventListener('resize', sync);
    const chrome = document.querySelector('.chrome');
    const ro = typeof ResizeObserver !== 'undefined' && chrome ? new ResizeObserver(sync) : null;
    if (ro && chrome) ro.observe(chrome);
    return () => {
      window.removeEventListener('resize', sync);
      ro?.disconnect();
    };
  }, []);
}

export const reduceMotion = () => !!window.matchMedia?.('(prefers-reduced-motion: reduce)').matches;
